import { useCallback, useEffect, useState } from 'react';
import type { AmplifierLocaleId } from './amplifierLanguage';
import {
  amplifierI18nService,
  type AmplifierTranslateParams,
} from './amplifierI18nService';
import type { AmplifierLocaleKey } from './locales';

export function useAmplifierI18n() {
  const [language, setLanguageState] = useState<AmplifierLocaleId>(
    amplifierI18nService.getLanguage(),
  );

  useEffect(() => {
    const handleChange = () => setLanguageState(amplifierI18nService.getLanguage());
    amplifierI18nService.addListener(handleChange);
    return () => amplifierI18nService.removeListener(handleChange);
  }, []);

  const setLanguage = useCallback((lang: AmplifierLocaleId) => {
    amplifierI18nService.setLanguage(lang);
  }, []);

  const t = (key: AmplifierLocaleKey, params?: AmplifierTranslateParams) =>
    amplifierI18nService.t(key, params);

  return { language, setLanguage, t };
}
